import { jsx as _jsx } from "react/jsx-runtime";
import MuiGlobalStyles from '@mui/material/GlobalStyles';
const GlobalStyles = ({ theme }) => {
    return (_jsx(MuiGlobalStyles, { styles: {
            ':root': {
                '--gp-radius-xs': '.125rem',
                '--gp-radius-sm': '.25rem',
                '--gp-radius-md': '.375rem',
                '--gp-radius-lg': '.5rem',
                '--gp-radius-xl': '.75rem',
                '--gp-radius-2xl': '1rem',
                '--gp-radius-3xl': '1.5rem',
                '--gp-radius-4xl': '2rem',
            },
            html: {
                height: '100%',
                // fontFeatureSettings: `'cv02', 'cv03', 'cv04', 'cv11'`. Tailwind font features. 'cv11' - different 'a' letter
                fontFeatureSettings: `'cv02', 'cv03', 'cv04'`,
            },
            body: {
                height: '100%',
            },
            '#root': {
                minHeight: '100%',
            },
            // Original fontawesome classes
            '@keyframes fa-spin': {
                '0%': {
                    transform: 'rotate(0deg)',
                },
                '100%': {
                    transform: 'rotate(360deg)',
                },
            },
            '.fa-spin': {
                animationName: 'fa-spin',
                animationDelay: 'var(--fa-animation-delay, 0s)',
                animationDirection: 'var(--fa-animation-direction, normal)',
                animationDuration: 'var(--fa-animation-duration, 2s)',
                animationIterationCount: 'var(--fa-animation-iteration-count, infinite)',
                animationTimingFunction: 'var(--fa-animation-timing, linear)',
            },
            // Removes new Chrome feature with black outline on :focus-visible
            ':focus-visible': {
                // outline: '-webkit-focus-ring-color auto 2px',
                outline: 'none',
            },
            '&.Mui-focusVisible': {
                outlineColor: theme.palette.primary.dark,
                outlineOffset: '2px',
                outlineWidth: '2px',
                outlineStyle: 'solid',
                zIndex: theme.zIndex.fab,
            },
            // Remove new Chrome 83 feature with black outline on :focus-visible
            // https://developer.chrome.com/blog/new-in-chrome-83/#forms
            // '*,*:focus,*:hover,*:focus-visible,*:active': {
            // 	outline: 'none',
            // },
            // '.MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected="true"]': {
            // 	background: 'dodgerblue', // change accordingly
            // 	color: 'white', // change accordingly
            // },
            // '.MuiAutocomplete-popper .MuiAutocomplete-option[role="option"][aria-selected="false"]:hover': {
            // 	//background: rgba(0, 0, 0, 0.1); // change accordingly
            // 	background: 'lightgrey', // change accordingly
            // },
        } }));
};
export { GlobalStyles };
